export const initHeroButtons = () => {
  const firstBtn = document.querySelector(
    '.et_pb_section.secondary-hero .et_pb_row:last-child .et_pb_column:first-child',
  );
  const secondBtn = document.querySelector(
    '.et_pb_section.secondary-hero .et_pb_row .et_pb_column:last-child .et_pb_button',
  );

  if (firstBtn && !secondBtn) {
    firstBtn.style.width = '100%';
  }

  const rows = document.querySelectorAll(
    '.et_pb_section.secondary-hero .et_pb_row',
  );

  if (rows.length === 2) {
    rows[0].style.marginBottom = '0';
    rows[1].style.marginTop = '0';
  }
};
